<template>
    <div class="d-flex flex-column h-100">
        <div
            v-if="event.startDate && event.endDate"
            class="d-flex justify-content-between justify-content-lg-start align-items-baseline gap-2 flex-wrap mb-1">
            <EventDate
                :start-date="event.startDate"
                :end-date="event.endDate"
                :open-end="event.openEnd" />
            <div v-if="event.icalContent">
                <EventEntryIcalElement :event="event" />
            </div>
        </div>
        <div v-if="event.isOnline">
            <font-awesome-icon icon="globe" />
            <EventEntryOnlineInfo
                :link="event.onlineLink"
                :application="event.onlineApplication"
                :appointment="isAppointment"
                hide-link
                with-pre-text />
        </div>
        <div
            v-else-if="event.location && event.location.name"
            class="my-1">
            <span>
                <font-awesome-icon
                    icon="map-marker-alt"
                    class="mr-2" />
                <strong> {{ event.location.name }}</strong><span
                    v-if="event.location.address && event.location.address.city">,
                    {{ event.location.address.city }}</span><span
                    v-if="event.location.address && event.location.address.district
                        && event.location.address.district !== event.location.address.city">
                    ({{ event.location.address.district }})
                </span>
                <el-tooltip v-if="event.location.lowBarrier && event.location.lowBarrier === 1">
                    <template #content>{{ $t('iFrame.lowBarrier') }}</template>
                    <font-awesome-icon icon="wheelchair" />
                </el-tooltip>
            </span>
        </div>
        <h1 class="mb-0">
            {{ event.name }}
        </h1>
        <h3 v-if="event.teaser">
            {{ event.teaser }}
        </h3>
        <EventCategories
            v-if="!hideCategories && event.categories"
            :categories="event.categories" />
        <div class="mb-2">
            <small v-if="event.ageFrom">{{ $t('iFrame.from') }}</small>
            <small v-if="event.ageFrom">{{ event.ageFrom }}</small>
            <small v-if="event.ageTo">{{ $t('iFrame.to') }}</small>
            <small v-if="event.ageTo">{{ event.ageTo }}</small>
            <small v-if="event.ageFrom || event.ageTo">{{ $t('iFrame.years') }}</small>
        </div>
        <div v-if="event.registrationLink && !registrationDeactivated">
            <EventEntryRegistrationButton :event="event" />
        </div>
        <h3 v-else-if="event.registrationLink && registrationPlanned">
            {{
                $t('iFrame.registrationPlanned', {registrationStart: $df($moment(event.registrationStart), 'dateNumeric')})
            }}
        </h3>
    </div>
</template>

<script>
import EventCategories from "@/components/pages/eventIFrame/EventEntry/EventEntryOverview/EventCategories";
import EventEntryIcalElement from "@/components/pages/eventIFrame/EventEntry/EventEntryOverview/EventEntryIcalElement";
import EventEntryRegistrationButton
    from "@/components/pages/eventIFrame/EventEntry/EventEntryOverview/EventEntryRegistrationButton";
import EventEntryOnlineInfo from './EventEntryOnlineInfo'
import EventDate from '../EventDate'

export default {
    name: "EventEntryEventInfo",
    components: {EventDate, EventEntryOnlineInfo, EventEntryRegistrationButton, EventEntryIcalElement, EventCategories},
    inject: ['iFrameType'],
    props: {
        event: {
            type: Object,
            required: true
        },
        hideCategories: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAppointment() {
            return this.iFrameType() === 'appointments'
        },
        registrationDeactivated() {
            if (this.event.registrationDeactivated) return true
            if (this.event.registrationStart && this.$moment().isSameOrBefore(this.$moment(this.event.registrationStart)))
                return true

            if (this.event.registrationEnd) {
                if (this.$moment(this.event.registrationEnd).isSame(this.$moment(this.event.registrationEnd).startOf('day'), 'second'))
                    return this.$moment(this.event.registrationEnd).endOf('day').isBefore(this.$moment())
                else
                    return this.$moment(this.event.registrationEnd).isBefore(this.$moment())
            }
            return false
        },
        registrationPlanned() {
            if (this.event.registrationDeactivated) return false
            if (this.event.registrationStart && this.$moment().isSameOrBefore(this.$moment(this.event.registrationStart)))
                return true
            return false
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
